import { editorialDashModuleQuery, useModule } from 'system/structure-modules';

export default function EditorialDashboardStoriesScreen() {
    const { StoriesManager } = useModule(editorialDashModuleQuery);
    return <StoriesManager />;
}
